import React from "react";
import styled from "styled-components";
import { H1 } from "../";
export const CalendarDay = ({
  month,
  day,
  ...props
}) => {
  return React.createElement(Container, props, React.createElement(Month, null, month), React.createElement(Day, null, day));
};
const Container = styled.div`
  background-color: #ffffff;
  display: block;
  height: 48px;
  width: 48px;
`;
const sharedStyles = `
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const Month = styled(H1).attrs({
  as: "div"
})`
  background-color: ${props => props.theme.colors.action};
  border-radius: 4px 4px 0 0;
  color: #ffffff;
  font-size: 11px;
  height: 18px;
  line-height: 13px;
  ${sharedStyles}
`;
const Day = styled(H1).attrs({
  as: "div"
})`
  border: 1px solid ${props => props.theme.colors.disabledFill};
  border-radius: 0 0 4px 4px;
  border-top: 0;
  box-sizing: border-box;
  font-size: 25px;
  line-height: 28px;
  height: 30px;
  ${sharedStyles}
`;